module.exports = __webpack_public_path__ + "img/exploded_view.04597ccc.png";